import { render, staticRenderFns } from "./applyActivitiesManagementView.vue?vue&type=template&id=70bfff08"
import script from "./applyActivitiesManagementView.vue?vue&type=script&lang=js"
export * from "./applyActivitiesManagementView.vue?vue&type=script&lang=js"
import style0 from "./applyActivitiesManagementView.vue?vue&type=style&index=0&id=70bfff08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports